import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log for observability; never surface stack traces to the user.
    console.error("UI error boundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen grid place-items-center bg-background px-6" data-testid="error-boundary">
          <div className="max-w-md text-center">
            <h1 className="font-display text-2xl font-bold text-slate-50">Something went wrong</h1>
            <p className="text-sm text-slate-400 mt-2">
              An unexpected error occurred. You can try again or head back to your dashboard.
            </p>
            <div className="flex items-center justify-center gap-3 mt-6">
              <button
                onClick={() => window.location.reload()}
                className="h-10 px-4 rounded-lg bg-primary hover:bg-emerald-600 text-white text-sm font-medium"
                data-testid="error-retry-btn"
              >
                Try again
              </button>
              <a
                href="/app"
                className="h-10 px-4 grid place-items-center rounded-lg border border-slate-700 text-slate-200 text-sm hover:bg-slate-800"
                data-testid="error-home-btn"
              >
                Go to dashboard
              </a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
